export const createPlaybook = `
    mutation createPlaybook($input: CreatePlaybookInput!) {
        createPlaybook(input:$input) {
            id
            name
            displayName
            description
            stateMachineArn
            inputSchema
            category
            status
            createdByUsername
            created
    }
}`;

export const updatePlaybook = `
    mutation updatePlaybook($input: UpdatePlaybookInput!) {
        updatePlaybook(input:$input){
            id
            name
            displayName
            description
            stateMachineArn
            inputSchema
            category
            status
            createdByUsername
            created
            updated
        }
}`;

export const deletePlaybook = `
    mutation deletePlaybook($input: DeletePlaybookInput!) {
        deletePlaybook(input:$input) {
            id
        }
}`;
